<template>
  <a :href="link" target="_blank" class="link with-arrow">
    <SpriteSymbol name="tram" />
    <span>{{ $texts('publicTransport', 'Public transport') }}</span>
  </a>
</template>

<script lang="ts" setup>
/*
import Vue from 'vue'
import { PropOptions } from 'vue/types'
export default Vue.extend({
 name: 'ZvvLink',
 props: {
   station: {
     type: String,
     default: '',
   } as PropOptions<string>,
 },
 computed: {
   link(): string {
     const lang = this.$store.state.language === 'de' ? 'de' : 'en'
     return `https://www.zvv.ch/zvv/${lang}/fahrplan/fp.html?toname=${encodeURI(
       this.station
     )}`
   },
 },
})
*/

const { $texts } = useEasyTexts()
const currentLanguage = useCurrentLanguage()

const props = withDefaults(
  defineProps<{
    station: string
  }>(),
  {
    station: '',
  },
)

const link = computed(() => {
  const lang = currentLanguage.value === 'de' ? 'de' : 'en'
  return `https://www.zvv.ch/zvv/${lang}/fahrplan/fp.html?toname=${encodeURI(props.station)}`
})
</script>
